export default __webpack_public_path__ + "static/media/songkla_aquarium.06be46ca.png";